import React, { useEffect, useState } from "react";
import RoomSelection from "../../../../components/admin/usable/RoomSelection";
import { Switch } from "@mui/joy";
import EditButton from "../../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../../components/admin/usable/actions/DeleteButton";
import { getFacilities } from "../../../../api/admin/facility";
import AddButton from "../../../../components/admin/usable/AddButton";
import { useDispatch, useSelector } from "react-redux";
import {
  setForAll,
  setShowFileUploader,
} from "../../../../redux/admin/fileManagerSlice";
import FileUploadandSelect from "../../../../components/admin/usable/fileuploader/FileUploadandSelect";
import CancelButton from "../../../../components/admin/usable/CancelButton";
import { addRoom } from "../../../../api/admin/room";
import { useNavigate } from "react-router";

const AddRoom = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showFileUploader, multiSelected } = useSelector(
    (state) => state.file,
  );
  const [FormData, setFormData] = useState({
    hotelId: "",
    roomName: "",
    description: "",
    beds: "",
    bathrooms: "",
    balcony: "",
    roomType: "",
    bedSize: "",
    roomSize: "",
    roomView: "",
    roomDirection: "",
    isSmokingAllow: 0,
    adults: 2,
    children: 1,
    actualPrice: 0,
    discount: 0,
    cancelationPolicy: "",
    isAvailable: 1,
    roomsAvailable: "",
    tax: 26.5,
    isRefundable: 1,
    status: 1,
    created_by: 6,
    createdAt: new Date().toISOString(),
    facilities: [],
    images: [],
  });
  const [FacilityData, setsetFacilityData] = useState([]);
  const [SelectedFacility, setSelectedFacility] = useState({
    useFor: "",
    facilities: [],
  });
  const [HotelId, setHotelId] = useState("");
  const [ImageFile, setImageFile] = useState([]);

  useEffect(() => {
    getFacilities(setsetFacilityData);
  }, []);
  const handleUseForChange = (e) => {
    setSelectedFacility((prev) => ({
      ...prev,
      useFor: e.target.value,
    }));
  };
  const handleSelectedFacility = () => {
    setFormData((prev) => {
      const existingIndex = prev.facilities.findIndex(
        (f) => f.useFor === SelectedFacility.useFor,
      );

      let updatedFacilities = [...prev.facilities];

      if (existingIndex !== -1) {
        updatedFacilities[existingIndex] = SelectedFacility;
      } else {
        updatedFacilities.push(SelectedFacility);
      }

      return {
        ...prev,
        facilities: updatedFacilities,
      };
    });

    setSelectedFacility({
      useFor: "",
      facilities: [],
    });
  };
  const handleSelectFacilities = (item) => {
    setSelectedFacility((prev) => {
      const alreadyExists = prev.facilities.some(
        (f) => f.facilityId === item.id,
      );

      return {
        ...prev,
        facilities: alreadyExists
          ? prev.facilities.filter((f) => f.facilityId !== item.id)
          : [
              ...prev.facilities,
              {
                facilityId: item.id,
                icon: item.icon,
                facilityName: item.facilityName,
              },
            ],
      };
    });
  };
  const handleFacilityEdit = (item) => {
    setSelectedFacility({
      useFor: item.useFor,
      facilities: item.facilities,
    });
  };
  const handleFacilityDelete = (item) => {
    setFormData((prev) => ({
      ...prev,
      facilities: prev.facilities.filter((f) => f.useFor !== item.useFor),
    }));
  };

  useEffect(() => {
    dispatch(setForAll(true));

    return () => {
      dispatch(setForAll(false));
    };
  }, [dispatch]);

  useEffect(() => {
    if (multiSelected && multiSelected.length > 0) {
      const newImages = multiSelected.map((item) => ({
        imageLink: item.fileLink.medium,
      }));

      setFormData((prev) => {
        const existingLinks = prev.images.map((img) => img.imageLink);

        const merged = [
          ...prev.images,
          ...newImages.filter((img) => !existingLinks.includes(img.imageLink)),
        ];

        return {
          ...prev,
          images: merged,
        };
      });

      setImageFile((prev) => {
        const existingLinks = prev.map((img) => img.imageLink);
        return [
          ...prev,
          ...newImages.filter((img) => !existingLinks.includes(img.imageLink)),
        ];
      });
    }
  }, [multiSelected]);
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      images: ImageFile,
    }));
  }, [ImageFile]);
  const handleRemoveImageLink = (link) => {
    setFormData((prev) => ({
      ...prev,
      images: prev.images.filter((img) => img.imageLink !== link),
    }));

    setImageFile((prev) => prev.filter((img) => img.imageLink !== link));
  };
  const handleUpload = () => {
    dispatch(setShowFileUploader(true));
    dispatch(setForAll(true));
  };
  const handleChangeFeatures = (field) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: prevData[field] === 1 ? 0 : 1,
    }));
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      hotelId: HotelId,
    }));
  }, [HotelId]);

  const handleSubmit = () => {
    addRoom(FormData, navigate);
  };
  return (
    <>
      {showFileUploader && <FileUploadandSelect />}
      <div className="space-y-10">
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Rooms Information</p>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-3 gap-3">
            <div className="space-y-3">
              <div>
                <label htmlFor="" className="text-xs">
                  Select Hotel
                </label>
                <RoomSelection setHotelId={setHotelId} HotelId={HotelId} />
              </div>
              <div className="grid grid-col-1 lg:grid-cols-3 gap-3">
                <div>
                  <label className="text-xs" htmlFor="">
                    Number of Beds
                  </label>
                  <input
                    type="number"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Beds"
                    onChange={handleChange}
                    id="beds"
                    value={FormData.beds}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Number of Bathrooms
                  </label>
                  <input
                    type="number"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Bathroom"
                    onChange={handleChange}
                    id="bathrooms"
                    value={FormData.bathrooms}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Number of Belcony
                  </label>
                  <input
                    type="number"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Belcony"
                    onChange={handleChange}
                    id="balcony"
                    value={FormData.balcony}
                  />
                </div>
              </div>
              <div className="grid grid-col-1 lg:grid-cols-3 gap-3">
                <div>
                  <label className="text-xs" htmlFor="">
                    Bed Size
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Bed Size"
                    onChange={handleChange}
                    id="bedSize"
                    value={FormData.bedSize}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Room Size
                  </label>
                  <input
                    type="number"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Bathroom"
                    onChange={handleChange}
                    id="roomSize"
                    value={FormData.roomSize}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Room View
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Room View"
                    onChange={handleChange}
                    id="roomView"
                    value={FormData.roomView}
                  />
                </div>
              </div>
              <div className="grid grid-col-1 lg:grid-cols-3 gap-3">
                <div>
                  <label className="text-xs" htmlFor="">
                    Smoking Allowed?
                  </label>
                  <br />
                  <Switch
                    onChange={() => handleChangeFeatures("isSmokingAllow")}
                    checked={FormData.isSmokingAllow === 1}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Available?
                  </label>
                  <br />
                  <Switch
                    onChange={() => handleChangeFeatures("isAvailable")}
                    checked={FormData.isAvailable === 1}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Refundable?
                  </label>
                  <br />
                  <Switch
                    onChange={() => handleChangeFeatures("isRefundable")}
                    checked={FormData.isRefundable === 1}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Breakfirst include?
                  </label>
                  <br />
                  <Switch
                    onChange={() => handleChangeFeatures("isBreakFastIncluded")}
                    checked={FormData.isBreakFastIncluded === 1}
                  />
                </div>
              </div>
            </div>
            <div>
              <div>
                <label className="text-xs" htmlFor="">
                  Room name
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                  placeholder="Room Name"
                  onChange={handleChange}
                  id="roomName"
                  value={FormData.roomName}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Room name
                </label>
                <textarea
                  rows={4}
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                  placeholder="Room description"
                  onChange={handleChange}
                  id="description"
                  value={FormData.description}
                />
              </div>
              {FormData.isRefundable === 1 && (
                <div>
                  <label className="text-xs" htmlFor="">
                    Cancelation Policy
                  </label>
                  <textarea
                    rows={4}
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Cancelation Policy"
                    onChange={handleChange}
                    id="cancelationPolicy"
                    value={FormData.cancelationPolicy}
                  />
                </div>
              )}
            </div>
            <div>
              <div className="space-y-3">
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-xs" htmlFor="">
                      Room Type
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                      placeholder="Room Type"
                      onChange={handleChange}
                      id="roomType"
                      value={FormData.roomType}
                    />
                  </div>
                  <div>
                    <label className="text-xs" htmlFor="">
                      Room Direction
                    </label>
                    <select
                      id="roomDirection"
                      onChange={handleChange}
                      value={FormData.roomDirection}
                      className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    >
                      <option value="">Select View</option>
                      <option value="South">South</option>
                      <option value="North">North</option>
                      <option value="East">East</option>
                      <option value="West">West</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-xs" htmlFor="">
                      Number of Adults
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                      placeholder="Adults"
                      onChange={handleChange}
                      id="adults"
                      value={FormData.adults}
                    />
                  </div>
                  <div>
                    <label className="text-xs" htmlFor="">
                      Number of Children
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                      placeholder="Children"
                      onChange={handleChange}
                      id="children"
                      value={FormData.children}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-3">
                  <div>
                    <label className="text-xs" htmlFor="">
                      Actual Price
                    </label>
                    <input
                      type="Number"
                      className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                      placeholder="Price"
                      onChange={handleChange}
                      id="actualPrice"
                      value={FormData.actualPrice}
                    />
                  </div>
                  <div>
                    <label className="text-xs" htmlFor="">
                      Discount
                    </label>
                    <input
                      type="Number"
                      className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                      placeholder="Discount (%)"
                      onChange={handleChange}
                      id="discount"
                      value={FormData.discount}
                    />
                  </div>
                  <div>
                    <label className="text-xs" htmlFor="">
                      Service Charge
                    </label>
                    <input
                      type="Number"
                      className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                      placeholder="Service Charge(%)"
                      onChange={handleChange}
                      id="tax"
                      value={FormData.tax}
                    />
                  </div>
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Availability of Rooms
                  </label>
                  <input
                    disabled={FormData.isAvailable === 0}
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Rooms"
                    onChange={handleChange}
                    id="roomsAvailable"
                    value={FormData.roomsAvailable}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Facilities</p>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-2 gap-3">
            <div>
              <div className="text-sm text-center">
                <p>Create Facility</p>
              </div>
              <div>
                <div>
                  <div>
                    <label className="text-xs" htmlFor="">
                      Facility For
                    </label>

                    <div className="flex gap-x-3">
                      <input
                        type="text"
                        className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                        placeholder="Facility For"
                        value={SelectedFacility.useFor}
                        onChange={handleUseForChange}
                      />
                      <AddButton
                        onClick={handleSelectedFacility}
                        text="Add Now"
                        size="sm"
                      />
                    </div>
                  </div>

                  <div>
                    {FacilityData && (
                      <div className="py-2 flex gap-2 flex-wrap">
                        {FacilityData.map((item, index) => {
                          const isSelected = SelectedFacility.facilities.some(
                            (f) => f.facilityId === item.id,
                          );

                          return (
                            <div key={index}>
                              <div
                                onClick={() => handleSelectFacilities(item)}
                                className={`flex justify-start items-center gap-x-2 border w-fit p-1 rounded-lg cursor-pointer transition 
                  ${
                    isSelected
                      ? "bg-blue-100 border-blue-500"
                      : "border-gray-300"
                  }
                `}
                              >
                                <div className="w-5 h-5 overflow-hidden rounded-lg">
                                  <img
                                    className="w-full h-full object-cover"
                                    src={item.icon}
                                    alt={item.facilityName}
                                  />
                                </div>

                                <p className="text-xs">{item.facilityName}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-3">
              <div>
                <p className="text-sm text-center">Selected Facilities</p>
              </div>
              <div>
                {FormData.facilities.length > 0 ? (
                  <>
                    <div className="space-y-3">
                      {FormData.facilities.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="border space-y-3 p-4 rounded-lg relative"
                          >
                            <div>
                              <p className="text-sm font-semibold">
                                {item.useFor}
                              </p>
                            </div>
                            <div className="flex justify-start items-end flex-wrap gap-3">
                              {item.facilities.map((facility, index) => {
                                return (
                                  <div key={index}>
                                    <div className="flex justify-start items-center gap-x-2 border w-fit p-2 rounded-lg">
                                      <div className="w-5 h-5 overflow-hidden rounded-lg">
                                        <img
                                          className="w-full h-full object-cover"
                                          src={facility.icon}
                                          alt={facility.facilityName}
                                        />
                                      </div>

                                      <p className="text-xs">
                                        {facility.facilityName}
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                            <div className="absolute -top-2 right-1 flex gap-x-1">
                              <EditButton
                                onClick={() => handleFacilityEdit(item)}
                              />
                              <DeleteButton
                                onClick={() => handleFacilityDelete(item)}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                ) : (
                  <div className="py-10 flex justify-center items-center">
                    <p className="text-sm text-black/50">
                      No Facilities Selected
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Select Images</p>
          </div>
          <div>
            {FormData.images.length > 0 ? (
              <>
                <div className="flex justify-start flex-wrap items-center gap-3">
                  {FormData.images.map((item, index) => {
                    return (
                      <div key={index} className="relative w-28 h-28">
                        <img
                          className="w-28 h-28 object-cover rounded-lg"
                          src={
                            item.imageLink ||
                            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                          }
                          alt=""
                        />
                        {item.imageLink && (
                          <div
                            onClick={() =>
                              handleRemoveImageLink(item.imageLink)
                            }
                            className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                          >
                            <p className="text-xs">Remove</p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                  <div>
                    <button
                      onClick={handleUpload}
                      className="p-4 border w-28 h-28 flex justify-center items-center text-2xl font-bold bg-white rounded-lg hover:bg-[#d3e8ff] duration-300"
                    >
                      +
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div>
                  <button
                    onClick={handleUpload}
                    className="p-4 border w-28 h-28 flex justify-center items-center text-2xl font-bold bg-white rounded-lg hover:bg-[#d3e8ff] duration-300"
                  >
                    +
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div className="flex justify-center items-center gap-3">
            <AddButton onClick={handleSubmit} text="Add Room" />
            <CancelButton text="Reset" />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRoom;
